// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ikk2","title":"styles_title___ijM8"};